import { memo, useEffect, useState } from 'react'
import { types_act } from './utils'

import { Button, TextField, Card, Select, FormControl, InputLabel, MenuItem } from '@mui/material'
import SearchIcon from '@material-ui/icons/Search'
import VirtualizedList from '../../components/VirtualizedList'
import CustomChip from '../../components/CustomChip'

const EMPTY_CODE_ACT = '0'

export default memo(({ classes, typeRecherche, filteredAllCenters, setFilteredAllActivites, allActivites, selectedCentre, filteredAllActivites, selectedActivite, setStep, setSelectedCentre, setStepContents, setSelectedActivite, setTypeRecherche, filter, allCenters, setFilteredAllCenters, setFilter, filterTypeAct, setFilterTypeAct, categories, filterCatAct, setFilterCatAct }) => {
  
  const [filtersAbo, setFiltersAbo] = useState({
    adulte: true,
    ado: true,
    enfant: true,
  })

  useEffect(() => {
    if(typeRecherche == 0) {
      const new_filter = allCenters.filter(c => c.CNT_LIBELLE.toLowerCase().includes(filter.toLowerCase()))
      setFilteredAllCenters(new_filter)
    } else {
      const new_filter = allActivites.filter(a => {
        if(!a.ACT_LIBELLE.toLowerCase().includes(filter.toLowerCase()) && filter !== '') return false
        if(filterTypeAct.id !== a.ACT_TA_ID && filterTypeAct.id !== 0) return false
        if(filterCatAct !== a.ACT_CODEACT_ID && filterCatAct !== EMPTY_CODE_ACT) return false
        if(!typeAboMatching(a)) return false
        return true
      })
      setFilteredAllActivites(new_filter)
    }
  }, [filter, filterTypeAct, filterCatAct, filtersAbo])

  function toggleFilterTypeAbo(tybeAbo) {
    let newFiltersAbo = { ... filtersAbo }
    newFiltersAbo[tybeAbo] = !newFiltersAbo[tybeAbo]
    setFiltersAbo(newFiltersAbo)
  }

  function typeAboMatching(a) {
    if(a.TYPE_ABO.includes('adulte') && filtersAbo.adulte) return true
    if(a.TYPE_ABO.includes('ado') && filtersAbo.ado) return true
    if(a.TYPE_ABO.includes('enfant') && filtersAbo.enfant) return true
    return false
  }
  
  return (
    <>
      <div>
        <div className={classes.tabs}>
          <div className={classes.tab_indicator} style={{ left: `${typeRecherche * 50}%` }}></div>
          <Button className={typeRecherche == 0 ? 'active' : ''} onClick={() => setTypeRecherche(0)}>Centres</Button>
          <Button className={typeRecherche == 1 ? 'active' : ''} onClick={() => setTypeRecherche(1)}>Activités</Button>
        </div>
        <div className={classes.filters}>
          <div className={`${classes.field} ${typeRecherche === 0 ? 'full' : ''}`} >
            <SearchIcon />
            <TextField
              label="Recherche"
              size="small"
              fullWidth
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
            />
          </div>
          {typeRecherche === 1 && (
            <div>
              <FormControl size="small" fullWidth >
                <InputLabel id="cat-label">Code</InputLabel>
              
                {categories.length && <Select
                  labelId="cat-label"
                  label="Catégorie"
                  value={filterCatAct}
                  onChange={(e) => setFilterCatAct(e.target.value)}
                >
                  {categories.map((c) => <MenuItem key={c.CODEACT_ID} value={c.CODEACT_ID}>{c.CODEACT_LIBELLE}</MenuItem>)}
                </Select> }
              </FormControl>
              <FormControl size="small" fullWidth >
                <InputLabel id="act-label">Type d'activité</InputLabel>
                <Select
                  labelId="act-label"
                  label="Type d'activité"
                  value={filterTypeAct}
                  onChange={(event) => setFilterTypeAct(event.target.value)}
                >
                  {types_act.map(c => <MenuItem key={c.id} value={c}>{c.libelle}</MenuItem>)}
                </Select>
              </FormControl>
            </div>
          )}
        </div>

        {typeRecherche === 1 && (
          <div className={classes.filters2}>
            <CustomChip enabled={filtersAbo.enfant} onClick={() => toggleFilterTypeAbo('enfant')} label="Enfant"/>
            <CustomChip enabled={filtersAbo.ado} onClick={() => toggleFilterTypeAbo('ado')} label="Ado"/>
            <CustomChip enabled={filtersAbo.adulte} onClick={() => toggleFilterTypeAbo('adulte')} label="Adulte"/>
          </div>
        )}
      </div>
      
      <Card variant="outlined" className={`${classes.lists} active-${typeRecherche}`}>
        <div>
          <VirtualizedList 
            items={filteredAllCenters}
            selectedItem={selectedCentre}
            keyLibelle="CNT_LIBELLE"
            onItemClick={(centre) => {
              setStep(1)
              setSelectedCentre(centre)
              setStepContents(previous => {
                const newStepContents = [...previous]
                newStepContents[0] = centre.CNT_LIBELLE
                return newStepContents
              })
            }}
          />
        </div>
        
        <div>
          <VirtualizedList 
            items={filteredAllActivites}
            selectedItem={selectedActivite}
            keyLibelle="ACT_LIBELLE"
            onItemClick={(activite) => {
              setStep(1)
              setSelectedActivite(activite)
              setStepContents(previous => {
                const newStepContents = [...previous]
                newStepContents[0] = activite.ACT_LIBELLE
                return newStepContents
              })
            }}
          />
        </div>
      </Card>
    </>
  )
})